import React, { useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';

const SolveProblems3D = props => {
  const slider = useRef();

  const settings = {
    infinite: true,
    speed: 300,
    swipe: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrow: false,
    autoplay: true,

    responsive: [
      {
        breakpoint: 767,
        settings: {
          autoplay: false,
          slidesToShow: 1,
          swipe: true,
          arrows: false,
          dots: true,
          dotsClass: 'custom-dots',
          centerMode: true,
          centerPadding: '25px',
        },
      },
    ],
  };

  return (
    <>
      <style>
        {`
              .solve-problems .slick-track {
                display:flex;
                margin:0
              }
              .solve-problems .slick-slide {
                width:33%;
                margin-right:5px
              }
              .solve-problems .slick-slide {
                outline: none
              }
              .solve-problems .slick-slide div {
                 outline: none
              }
              .solve-problems .slick-slide:focus,.slick-slide a {
                outline: none;
              }
              .shadow-new {
                box-shadow: 0px 1px 3px 1px rgb(0 0 0 / 7%);
                border-radius: 0px 0px 25px 25px;
              }
              .shadow-new-w {
                box-shadow: 0px 1px 6px 1px rgb(0 0 0 / 7%);
              }
              .custom-dots {
                display:flex!important;
                justify-content:center;
              }
              .custom-dots li {
                position:relative;
                margin:0 3px;
                margin-top:20px;
                width:50px;
                height:2px;
                background-color: #C4C4C4; 
                overflow:hidden;
              }
              .custom-dots li.slick-active {
                background-color:#670F7A;
              }
              .custom-dots li button {
                position:absolute;
                width:100%;
                height:100%;
                top:0;
                left:0;
                opacity:0;
              }
              .slick-list:first-of-type,for-hover:first-of-type {
                padding-left:0!important;
              }
        `}
      </style>

      <Slider ref={slider} {...settings} className="solve-problems relative z-10 pt-24  ">
        <div className={'w-30p block mr-10 pr-0 md:pr-15'}>
          <div className={'bg-gray-slideOne px-18 py-12  min-h-340 md:min-h-280'}>
            <h3 className={'font-bold text-24 leading-29 text-purple'}>Promote a physical product or service</h3>
            <div className={'pr-0 md:pr-30'}>
              <p className={'mt-10'}>
                {' '}
                In a 3D explainer video, the value you create is always the main character of the story, presented in detail and clarity.
              </p>
            </div>
          </div>
        </div>
        <div className={'w-30p mr-10 px-0 md:px-15'}>
          <div className={'bg-red-slideTwo px-18 py-12  min-h-340 md:min-h-280'}>
            <h3 className={'font-bold text-24 leading-29 text-purple'}>Increase brand awareness.</h3>
            <div className={'mt-10'}>
              <p className={'mt-10'}>A well-designed 3D animated explainer video memorably presents your brand's personality and strengths.</p>
            </div>
          </div>
        </div>
        <div className={'w-30p mr-10 pl-0 md:pl-15'}>
          <div className="bg-blue-slideTree px-18 py-12  min-h-340 md:min-h-280">
            <h3 className={'font-bold text-24 leading-29 text-purple'}>Tell the brand story.</h3>
            <p className={'mt-10'}>
              3D video can evoke a strong emotional response to establish deep and meaningful connections with target audiences. {' '}
            </p>
          </div>
        </div>
      </Slider>
    </>
  );
};
export default SolveProblems3D;
